
$(function() {
    function togglePasswordVisibility(passwordInput, iconElement) {
        var isPassword = 'password' === passwordInput.getAttribute('type');
        iconElement.classList.toggle('fa-eye-slash', isPassword);
        iconElement.classList.toggle('fa-eye', !isPassword);
        passwordInput.type = isPassword ? 'text' : 'password';
    }

    function revealPassword() {
        var inputPassword = document.querySelectorAll('input[type="password"].togglable-password');
        inputPassword.forEach(function (elem) {

            const initialized = elem.getAttribute('data-initialized');
            const initializing =elem.getAttribute('data-initializing');

            if (!initialized && !initializing) {
                elem.setAttribute('data-initializing', true);
                var i = Math.random().toString(36).substr(2, 9);
                var revealPasswordId = 'reveal-password_' + i;
                elem.insertAdjacentHTML('afterend', '<span id="' + revealPasswordId + '"><i class="fa fa-eye field-icon toggle-password"></i></span>');
                var revealPassword = document.querySelector('#' + revealPasswordId);
                var iconElement = document.querySelector('#' + revealPasswordId + ' i');
                revealPassword.addEventListener('click', function(event) {
                    togglePasswordVisibility(elem, iconElement);
                });
                elem.setAttribute('data-initialized', true);
                elem.setAttribute('data-initializing', true);
            }
        });

    }
    $( document ).on( "ajaxComplete", function() {
      revealPassword();
    } );
    revealPassword();
});
